import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMacos = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "icon-wrapper",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Union",
			d: "M9.78086 7.32402C9.77539 6.3916 10.1979 5.68887 11.051 5.1707C10.5738 4.48711 9.85195 4.11113 8.90039 4.03867C7.99941 3.96758 7.01367 4.56367 6.65273 4.56367C6.27129 4.56367 5.39902 4.06328 4.7127 4.06328C3.29629 4.08516 1.79102 5.19258 1.79102 7.4457C1.79102 8.11152 1.9127 8.79922 2.15605 9.50742C2.48145 10.4398 3.65449 12.7244 4.87812 12.6875C5.51797 12.6725 5.97051 12.2336 6.80312 12.2336C7.61113 12.2336 8.02949 12.6875 8.74316 12.6875C9.97773 12.6697 11.0387 10.593 11.3477 9.65781C9.69199 8.87715 9.78086 7.37188 9.78086 7.32402V7.32402ZM8.34395 3.1541C9.03711 2.33105 8.97422 1.58184 8.95371 1.3125C8.34121 1.34805 7.63301 1.72949 7.22969 2.19844C6.78535 2.70156 6.52422 3.32363 6.58027 4.025C7.24199 4.07559 7.84629 3.73516 8.34395 3.1541V3.1541Z",
			fill: "currentColor"
		})
	})]
});
const ForwardRef = forwardRef(SvgMacos);
export { ForwardRef as ReactComponent };
